"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _I18n = _interopRequireDefault(require("I18n"));

var _UIButton = _interopRequireDefault(require("./UIButton"));

var _UITooltip = _interopRequireDefault(require("../tooltip/UITooltip"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var UICopyButton =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(UICopyButton, _React$Component);

  function UICopyButton(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UICopyButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UICopyButton).call(this, props));
    _this.state = {
      tooltipActive: false
    };
    _this.handleTooltipOpenChange = _this.handleTooltipOpenChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(UICopyButton, [{
    key: "handleTooltipOpenChange",
    value: function handleTooltipOpenChange(evt) {
      // Every time the tooltip opens, reset to the original title
      if (evt.target.value) {
        if (this.state.tooltipActive) this.setState({
          tooltipActive: false
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(evt) {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          value = _this$props.value,
          valueWhenCopied = _this$props.valueWhenCopied;
      var textarea = document.createElement('textarea');
      var buttonEl = (0, _reactDom.findDOMNode)(this);
      var parentEl = buttonEl.parentElement;
      parentEl.appendChild(textarea);
      textarea.value = valueWhenCopied(value);
      textarea.select();
      textarea.setSelectionRange(0, 999999); // Needed for iOS Safari

      try {
        document.execCommand('copy');
        this.setState({
          tooltipActive: true
        });
      } catch (err) {
        /* Ignore error */
      }

      parentEl.removeChild(textarea); // Restore focus to the button element

      buttonEl.focus();
      if (onClick) onClick(evt);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          hint = _this$props2.hint,
          hintSuccess = _this$props2.hintSuccess,
          __onClick = _this$props2.onClick,
          tooltipClassName = _this$props2.tooltipClassName,
          tooltipPlacement = _this$props2.tooltipPlacement,
          __value = _this$props2.value,
          __valueWhenCopied = _this$props2.valueWhenCopied,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "hint", "hintSuccess", "onClick", "tooltipClassName", "tooltipPlacement", "value", "valueWhenCopied"]);
      var tooltipActive = this.state.tooltipActive;
      var tooltipTitle = tooltipActive ? (0, _lazyEval.default)(hintSuccess) : (0, _lazyEval.default)(hint);

      var renderedButtonContent = children || _react.default.createElement("span", {
        className: "private-button--internal-spacing"
      }, _I18n.default.text('salesUI.UICopyInput.label'));

      return _react.default.createElement(_UITooltip.default, {
        className: tooltipClassName,
        disabled: !tooltipTitle,
        onOpenChange: this.handleTooltipOpenChange,
        placement: tooltipPlacement,
        title: tooltipTitle
      }, _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, rest, {
        onClick: this.handleClick
      }), renderedButtonContent));
    }
  }]);
  return UICopyButton;
}(_react.default.Component);

UICopyButton.propTypes = {
  children: _react.PropTypes.node,
  hint: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
  hintSuccess: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
  onClick: _react.PropTypes.func,
  tooltipClassName: _react.PropTypes.string,
  tooltipPlacement: _UITooltip.default.propTypes.placement,
  use: _UIButton.default.propTypes.use,
  value: _react.PropTypes.any,
  valueWhenCopied: _react.PropTypes.func
};
UICopyButton.defaultProps = {
  hint: function hint() {
    return _I18n.default.text('salesUI.UICopyInput.title');
  },
  hintSuccess: function hintSuccess() {
    return _I18n.default.text('salesUI.UICopyInput.tooltipCopied');
  },
  tooltipPlacement: 'top',
  use: 'tertiary-light',
  valueWhenCopied: function valueWhenCopied(value) {
    return value;
  }
};
UICopyButton.displayName = 'UICopyButton';
var _default = UICopyButton;
exports.default = _default;
module.exports = exports.default;